import { VueModule } from '@Foundation/utilities';
import ArticleList from './code/Scripts/components/article-list.vue';

export default VueModule({
    components: {
        ArticleList
    }
});